import React from "react";
import { openEngineData } from "../../utils/constant";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper/core";
import SectionHeader from "./SectionHeader";
SwiperCore.use([Autoplay, Pagination, Navigation]);

const { testimonialCols } = openEngineData;

const Testimonial = ({ testimonial }) => {
  return (
    <div className="testimonial">
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: testimonial.review }}
      />
      <div className="testimonial-footer">
        <img src={testimonial.image} alt={testimonial.name} />
        <div>
          <h5 className="name">{testimonial.name}</h5>
          <p className="designation">{testimonial.designation}</p>
        </div>
      </div>
    </div>
  );
};

const Testimonials = () => {
  return (
    <div className="open-engine-testimonials">
      <SectionHeader
        subtitle="Testimonials"
        title="What users love about OpenEngine"
      />
      <div className="testimonials-columns desktop">
        {testimonialCols.map((testimonialCol, index) => (
          <div key={index} className="testimonials-column">
            {testimonialCol.map((testimonial, index) => (
              <Testimonial key={index} testimonial={testimonial} />
            ))}
          </div>
        ))}
      </div>

      <Swiper
        pagination={true}
        slidesPerView={1}
        spaceBetween={25}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
          },
        }}
        className="mySwiper testimonials-columns mobile"
      >
        {testimonialCols.map((testimonialCol) => {
          return testimonialCol.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div key={index} className="testimonial">
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: testimonial.review }}
                />
                <div className="testimonial-footer">
                  <img src={testimonial.image} alt={testimonial.name} />
                  <div>
                    <h5 className="name">{testimonial.name}</h5>
                    <p className="designation">{testimonial.designation}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ));
        })}
      </Swiper>
    </div>
  );
};

export default Testimonials;
